import { render, staticRenderFns } from "./ImageContent.vue?vue&type=template&id=60f7c82a&scoped=true&"
import script from "./ImageContent.vue?vue&type=script&lang=js&"
export * from "./ImageContent.vue?vue&type=script&lang=js&"
import style0 from "./ImageContent.vue?vue&type=style&index=0&id=60f7c82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f7c82a",
  null
  
)

export default component.exports